module.exports = __webpack_public_path__ + "static/media/social_facebook.732672c0.svg";